import { useState } from 'react';

import styles from '../PasswordManagement.module.less';

import {
    Alert,
    Button,
    CallToAction,
    Col,
    FormControl,
    FormikForm,
    Row
} from '$HVUI/HVUI';
import { useFetch } from '$Hooks';
import yup from '$Validation/yup';

const { number, object, string } = yup;

// Minimum password strength requirement for patient(1) or provider(3)
const requiredStrength = window.isProvider ? 3 : 1;

const validationSchema = object().shape({
    password: string().passwordStrength(requiredStrength),
    'confirm-password': string().confirmPassword('password'),
    password_score: number()
});

const ChangeForm = props => {
    const [success, setSuccess] = useState(false);

    const { error, loading, post, response } = useFetch(
        '/api/v2/change-password/'
    );

    if (success) {
        return (
            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                <Row gutter={[0, 24]} align="center" justify="center">
                    <Col>
                        <h1 style={{ marginBottom: '1rem' }}>
                            Your password has been reset.
                        </h1>
                        <p>You may now sign in with your new password.</p>
                    </Col>
                </Row>
                <Row align="center" justify="center">
                    <Col>
                        <CallToAction
                            text="Home"
                            href="/signin"
                            color="ocean"
                            level="primary"
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div className={styles['confirm-container']}>
            {error && (
                <Alert
                    message="Sorry, we can't set your password right now.  Please refresh or try again later."
                    style={{ marginBottom: '1.5rem' }}
                    type="error"
                />
            )}
            <Row gutter={48} align="center">
                <Col md={12}>
                    <h1>Change your password</h1>
                    <p>
                        Your password has expired. Please create a new password
                        to login to Healthvana. Here are some tips for creating
                        a secure password:
                    </p>
                    <ul>
                        <li className={styles['list-item']}>
                            Don’t use any words that contain information about
                            you, especially something someone could look up.
                        </li>
                        <li className={styles['list-item']}>
                            Unusual words are best.
                        </li>
                        <li className={styles['list-item']}>
                            The longer the password, the better. Using more than
                            one word to lengthen the password is a great idea.
                        </li>
                    </ul>
                </Col>
                <Col md={12}>
                    <FormikForm
                        initialValues={{
                            password: '',
                            'confirm-password': '',
                            password_score: 0
                        }}
                        onSubmit={async values => {
                            // switching the names because
                            // the endpoint expects these
                            const {
                                password: new_password1,
                                'confirm-password': new_password2
                            } = values;
                            await post({
                                new_password1,
                                new_password2
                            });
                            if (response.ok) {
                                setSuccess(true);
                            }
                        }}
                        validationSchema={validationSchema}
                    >
                        <FormControl
                            disabled={loading}
                            name="password"
                            type="password"
                            label="Password"
                            useStrengthMeter={true}
                        />
                        <FormControl
                            disabled={loading}
                            name="confirm-password"
                            type="password"
                            label="Confirm Password"
                        />
                        <Button
                            {...props}
                            disabled={loading}
                            id="button-submit"
                            type="submit"
                            level="primary"
                            text="Reset Password"
                        />
                    </FormikForm>
                </Col>
            </Row>
        </div>
    );
};

export default ChangeForm;
